<div
  class="flex flex-col flex-1 h-full w-full min-w-0 overflow-hidden bg-component-inner"
>
  <div
    class="w-full p-4 border-b border-primary-border flex justify-between items-center bg-component-header shrink-0"
  >
    <div class="flex items-center gap-2">
      <i class="fas fa-bug text-primary"></i>
      <span class="font-bold text-primary-text">Execution Debugger</span>
    </div>
  </div>

  <div
    class="w-full flex px-4 py-2 border-b border-primary-border bg-alt-background gap-4 shrink-0 min-w-0 overflow-hidden"
  >
    <button
      (click)="activeDebugTab.set('state')"
      class="text-sm focus:outline-none transition-colors border-b-2"
      [ngClass]="
        activeDebugTab() === 'state'
          ? 'text-primary font-bold border-primary'
          : 'text-secondary-text font-medium border-transparent hover:text-primary'
      "
    >
      Live State
    </button>
    <button
      (click)="activeDebugTab.set('events')"
      class="text-sm focus:outline-none transition-colors border-b-2"
      [ngClass]="
        activeDebugTab() === 'events'
          ? 'text-primary font-bold border-primary'
          : 'text-secondary-text font-medium border-transparent hover:text-primary'
      "
    >
      Event Log
    </button>
  </div>

  <div
    class="w-full flex-1 flex flex-col bg-body-background min-h-0 min-w-0 overflow-hidden"
  >
    @if (activeDebugTab() === 'state') {
      <div class="w-full flex-1 h-full min-h-0 min-w-0 overflow-hidden">
        <rapider-monaco-code-editor
          [code]="debugStateString()"
          language="json"
          [readOnly]="true"
          class="w-full h-full block"
        >
        </rapider-monaco-code-editor>
      </div>
    } @else {
      <div
        class="w-full p-4 flex-1 overflow-y-auto custom-scrollbar flex flex-col gap-3 min-h-0 min-w-0"
      >
        <div class="w-full flex justify-between items-center mb-1 shrink-0">
          <span
            class="text-xs font-bold text-secondary-text uppercase tracking-wider truncate mr-2"
            >Event Log</span
          >
          <button
            (click)="clearDebugEvents()"
            class="text-xs font-semibold text-danger hover:text-danger/80 focus:outline-none bg-danger/10 px-2 py-0.5 rounded transition-colors shrink-0"
          >
            Clear Logs
          </button>
        </div>

        @for (ev of debugEventsLog(); track ev.timestamp) {
          <div
            class="w-full flex flex-col p-3 bg-component-inner border border-secondary-border rounded-xl shadow-sm mb-2 shrink-0 min-w-0 overflow-hidden"
          >
            <div
              class="w-full flex items-center justify-between border-b border-secondary-border pb-2 mb-2 min-w-0"
            >
              <span class="text-sm font-bold text-primary truncate mr-2">{{
                ev.eventName
              }}</span>
              <span
                class="text-[10px] text-secondary-text font-mono shrink-0"
                >{{ ev.timestamp | date: 'HH:mm:ss.SSS' }}</span
              >
            </div>

            <div class="w-full flex items-center gap-2 mb-2 shrink-0">
              <span
                class="!m-0 text-[10px] uppercase font-bold tracking-wider px-2 py-0.5 rounded"
                [ngClass]="
                  ev.type === 'action_error'
                    ? 'bg-danger/10 text-danger'
                    : ev.type === 'endpoint_success'
                      ? 'bg-success/10 text-success'
                      : 'bg-primary/10 text-primary'
                "
              >
                {{ ev.type }}
              </span>
            </div>

            @if (ev.context) {
              <div class="w-full mt-1 min-w-0 overflow-hidden">
                <span
                  class="text-[10px] font-semibold text-secondary-text uppercase mb-1 block truncate"
                  >Context Payload (pageState):</span
                >
                <pre
                  class="w-full text-[10px] font-mono text-primary-text bg-alt-background p-2 rounded border border-secondary-border overflow-x-auto custom-scrollbar max-h-32 min-w-0"
                  >{{ ev.context | json }}</pre
                >
              </div>
            }

            @if (ev.error) {
              <div
                class="w-full mt-1 bg-danger/10 text-danger p-2 rounded text-[10px] font-mono border border-danger/20 min-w-0 overflow-hidden break-words"
              >
                {{ ev.error }}
              </div>
            }
          </div>
        }

        @if (debugEventsLog().length === 0) {
          <div
            class="w-full text-center p-6 border border-dashed border-secondary-border rounded-xl text-secondary-text text-sm italic shrink-0"
          >
            No events tracked yet. Click buttons on your layout to trace
            actions.
          </div>
        }
      </div>
    }
  </div>
</div>
